var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { memoize } from '@core/utils/hoc/memo.utils';
import { BiArrowFromLeft, BiArrowFromRight } from 'react-icons/bi';
import { twMerge } from 'tailwind-merge';
export var PaginationButton = memoize(function (_a) {
    var type = _a.type, selected = _a.selected, clickHandle = _a.clickHandle, pageNumber = _a.pageNumber, disabled = _a.disabled;
    return (_jsx("button", __assign({ disabled: disabled, onClick: clickHandle, className: twMerge('flex h-[32px] w-[32px] cursor-pointer items-center justify-center rounded-lg border-[1px] border-[#EDEFF2] disabled:cursor-default', selected && 'border-primary text-primary') }, { children: type === 'page' ? (pageNumber) : type === 'part' ? ('...') : type === 'left' ? (_jsx(BiArrowFromRight, {})) : (_jsx(BiArrowFromLeft, {})) })));
}, 'PaginationButton');
